import { planningAPI } from "../../axios";

export const actions = {
    //Planning Template
    CreateMainTarget(context, data){
        return planningAPI.post(`PlanningMainTarget/Add`, data);
    },
    UpdateMainTarget(context, data){
        return planningAPI.put(`PlanningMainTarget/Update/${data.id}`, data);
    },
    DeleteMainTarget(context, data){
        return planningAPI.delete(`PlanningMainTarget/Delete/${data}`);
    },
    GetSingleMainTarget(context, data){
        return planningAPI.get(`PlanningMainTarget/${data}`);
    },
    GetMainTargetByIndicator(context, data){
        return planningAPI.get(`PlanningMainTarget/IndicatorItem/${data.indicatorItemId}/${data.cycle}/${data.campusId}`);
    },
    PostMainTarget(context, data){
        return planningAPI.post(`PlanningMainTarget/Post/${data}`);
    }
}